<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('attendance_details')">
            <app-default-button
                btn-class="btn btn-primary mr-1"
                :title="$t('export_excel')"
                @click="downloadExportFile"
            />
          <app-default-button
              btn-class="btn btn-primary mr-1"
              :title="$t('exportPDF')"
              @click="downloadExportPDF"
          />
        </app-page-top-section>
        <app-filter-with-search
            :options="options"
            @filteredValue="setFilterValues"
            @searchValue="setSearchValue"
        />

        <div class="card card-with-shadow border-0" style="min-height: 400px;">
            <div class="card-body">
                <div class="summery-calendar">
                    <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between mb-primary">
                        <app-month-calendar :show-date-range-calendar="true"/>

                        <app-period-calendar :showThisYear="false"/>
                    </div>
                    <app-overlay-loader v-if="loading"/>

                    <div class="d-flex" v-else-if="$optional(attendances, 'data', 'length')">
                        <div class="profile-column">
                            <div class="column-header">{{ $t('profile') }}</div>
                            <template v-for="employee in attendances.data">
                                <app-employee-profile-card :employee="employee"/>
                            </template>
                        </div>
                        <!--                        <div class="total-hour-column">-->
                        <!--                            <div class="column-header">{{ $t('total') }}</div>-->
                        <!--                            <app-employee-work-hour-type v-for="employee in attendances.data"-->
                        <!--                                                         :attendance-summery="getAttendanceSummaries(employee)"-->
                        <!--                                                         :key="employee.id"-->
                        <!--                            />-->
                        <!--                        </div>-->
                        <div class="date-column custom-scrollbar custom-scrollbar-with-mouse-move">
                            <div class="d-flex">
                                <div class="date-value-wrapper" v-for="range in ranges">
                                    <div class="date">
                                        {{ formatTitleRangeDate(range) }}
                                    </div>
                                    <div class="date-hour-wrapper text-center"
                                         v-for="employee in attendances.data"
                                         v-html="formatEmployeeAttendances(employee, range)"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <app-empty-data-block v-else :message="$t('nothing_to_show_here')"/>
                    <app-pagination
                        v-if="attendances.total && attendances.last_page > 1"
                        :rowLimit="attendances.per_page"
                        :totalRow="attendances.total"
                        @submit="setPagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppEmployeeProfileCard from "./Component/AppEmployeeProfileCard";
import AppEmployeeWorkHourType from "./Component/AppEmployeeWorkHourType";
import AppEmployeeWorkingDate from "./Component/AppEmployeeWorkingDate";
import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {ATTENDANCES} from "../../../Config/ApiUrl";
import {
    DepartmentFilterMixin,
    DesignationFilterMixin,
    EmploymentStatusFilterMixin,
    WorkingShiftFilterMixin
} from '../../Mixins/FilterMixin';
import AppAttendanceTopButtons from "./Component/AppAttendanceTopButtons";
import moment from 'moment'
import {
    convertSecondToHourMinutes,
    differentInTime, serverDateFormat,
    serverDateTimeFormat, serverTimeFormat
} from "../../../../common/Helper/Support/DateTimeHelper";
import optional from "../../../../common/Helper/Support/Optional";
import MemoizeMixins from "../../../../common/Helper/Support/MemoizeMixins";
import AttendanceHelperMixin from "../../Mixins/AttendanceHelperMixin";
import TemplateHelper from "../../../../core/helpers/template-helper/TemplateHelper";
import AttendanceSummaryDetailsMixin from "../../Mixins/AttendanceSummaryDetailsMixin";
import jsPDF from 'jspdf';


// Import the necessary functions from the xlsx library
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    name: "AttendanceDetails",
    components: {
        AppEmployeeWorkingDate,
        AppEmployeeWorkHourType,
        AppEmployeeProfileCard,
        AppAttendanceTopButtons
    },
    mixins: [DepartmentFilterMixin, DesignationFilterMixin, EmploymentStatusFilterMixin, WorkingShiftFilterMixin, MemoizeMixins, AttendanceHelperMixin, AttendanceSummaryDetailsMixin],
    methods: {
        downloadExportFile() {
            // Your data preparation logic here
            const excelData = this.attendances.data.map(employee => {
                const employeeData = this.ranges.reduce((result, range) => {
                    result[range.format('YYYY-MM-DD')] = this.formatEmployeeAttendances(employee, range);
                    return result;
                }, {});
                return {
                    Name: employee.full_name,
                    ...employeeData
                };
            });

            // Convert the data to worksheet
            const ws = XLSX.utils.json_to_sheet(excelData, { header: ['Name', ...this.ranges.map(range => range.format('YYYY-MM-DD'))] });

            // Create a workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');

            // Convert the workbook to a binary Excel file and save it
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'attendance_data.xlsx');
        },
      downloadExportPDF() {
        const doc = new jsPDF('landscape');

        doc.setProperties({
          title: 'Attendance Data PDF'
        });

        const monthName = `Attendance report of ${this.ranges[0].format('MMMM')} ${this.ranges[0].format('YYYY')}`;
        doc.setFontSize(7);
        doc.text(monthName, 140, 10, { align: 'center' });

        // Calculate initial x-coordinate for date headers
        let xDate = 60; // Start the date headers after the name column

        const yStart = 20;
        let y = yStart;

        const nameColumnWidth = 50; // Increased width for the name column
        const availableWidth = 280;

        // Decrease the space between columns
        const dateColumnWidth = (availableWidth - nameColumnWidth) / (this.ranges.length + 1);

        // Add date headers at the top with padding/margin
        this.ranges.forEach((range, index) => {
          const formattedDate = range.format('D');
          doc.text(formattedDate, xDate, y, { align: 'center' });
          xDate += dateColumnWidth; // Adjust x-coordinate for the next date header
        });

        // Reset x-coordinate for employee names
        let xName = 10; // Start the names from the leftmost position

        // Adjust y-coordinate for employee data
        y = yStart + 10;

        // Determine the total number of rows
        const totalRows = this.attendances.data.length;

        // Loop through employees and add data
        this.attendances.data.forEach((employee, rowIndex) => {
          doc.setFontSize(7);
          doc.text(`${employee.full_name}`, xName, y, { align: 'left', maxWidth: nameColumnWidth });

          xName += nameColumnWidth;

          // Reset x-coordinate for date headers
          xDate = 60; // Start the date headers after the name column

          this.ranges.forEach((range, index) => {
            const dayData = this.formatEmployeeAttendances(employee, range);
            // Center-align the attendance record horizontally
            doc.text(dayData, xDate, y, { align: 'center', maxWidth: dateColumnWidth - 5 });
            xDate += dateColumnWidth; // Adjust x-coordinate for the next date header
          });

          // Move to the next line for the next employee
          if (rowIndex !== totalRows - 1) {
            y += 8; // Adjusted line spacing for employee data
          }

          // Check if the next row will exceed the page height, if so, add a new page
          if (y > 250 && rowIndex !== totalRows - 1) {
            doc.addPage('landscape');
            y = yStart;
          }

          // Reset x-coordinate for the next employee if there are more rows
          if (rowIndex !== totalRows - 1) {
            xName = 10;
          }
        });

        doc.save('attendance_data.pdf');
      },
      // downloadExportPDF() {
      //   const doc = new jsPDF('landscape');
      //
      //   doc.setProperties({
      //     title: 'Attendance Data PDF'
      //   });
      //
      //   const monthName = `Attendance report of ${this.ranges[0].format('MMMM')} ${this.ranges[0].format('YYYY')}`;
      //   doc.setFontSize(7);
      //   doc.text(monthName, 140, 10, { align: 'center' });
      //
      //   // Calculate initial x-coordinate for date headers
      //   let xDate = 60; // Start the date headers after the name column
      //
      //   const yStart = 20;
      //   let y = yStart;
      //
      //   const nameColumnWidth = 50; // Increased width for the name column
      //   const availableWidth = 280;
      //
      //   // Decrease the space between columns
      //   const dateColumnWidth = (availableWidth - nameColumnWidth) / (this.ranges.length + 1);
      //
      //   // Add date headers at the top with padding/margin
      //   this.ranges.forEach((range, index) => {
      //     const formattedDate = range.format('D');
      //     doc.text(formattedDate, xDate, y, { align: 'center' });
      //     xDate += dateColumnWidth; // Adjust x-coordinate for the next date header
      //   });
      //
      //   // Reset x-coordinate for employee names
      //   let xName = 10; // Start the names from the leftmost position
      //
      //   // Adjust y-coordinate for employee data
      //   y = yStart + 10;
      //
      //   // Loop through employees and add data
      //   this.attendances.data.forEach(employee => {
      //     doc.setFontSize(7);
      //     doc.text(`${employee.full_name}`, xName, y, { align: 'left', maxWidth: nameColumnWidth });
      //
      //     xName += nameColumnWidth;
      //
      //     // Reset x-coordinate for date headers
      //     xDate = 60; // Start the date headers after the name column
      //
      //     this.ranges.forEach((range, index) => {
      //       const dayData = this.formatEmployeeAttendances(employee, range);
      //       // Center-align the attendance record horizontally
      //       doc.text(dayData, xDate, y, { align: 'center', maxWidth: dateColumnWidth - 5 });
      //       xDate += dateColumnWidth; // Adjust x-coordinate for the next date header
      //     });
      //
      //     // Reset x-coordinate for the next employee
      //     xName = 10;
      //
      //     // Move to the next line for the next employee
      //     y += 8; // Adjusted line spacing for employee data
      //   });
      //
      //   doc.save('attendance_data.pdf');
      // },




      getAttendances(queryString) {
            this.loading = true;
            axiosGet(`${ATTENDANCES}/details?${queryString}`).then(response => {
                this.attendances = response.data.attendances;
                this.ranges = response.data.range.map(range => moment(range, serverDateTimeFormat));
                this.defaultWorkingShift = response.data.default;
            }).finally(() => {
                this.loading = false;
                TemplateHelper.moveHorizontalScrollbarWithMouse();
            })
        },
        // formatEmployeeAttendances(employee, date) {
        //     const attendance = this.getAttendance(employee, date);
        //
        //     const workShiftDetails = this.getDetails(
        //         this.getEmployeeWorkingShiftFromDate(
        //             employee.working_shifts,
        //             date,
        //             this.defaultWorkingShift
        //         ),
        //         date,
        //     );
        //
        //     const holiday = this.isHoliday(date, employee.holidays);
        //
        //     const scheduled = holiday ? moment.duration('00:00') : this.getScheduled(workShiftDetails);
        //
        //     const paid_leave = Number(this.getTotalPaidLeave(employee, workShiftDetails, date, holiday));
        //
        //     if (!attendance) {
        //
        //         if (scheduled.asSeconds() > 0) {
        //             if (paid_leave > 0) {
        //                 return `<div class="date-hour">${paid_leave ? 'L' : 'A'}</div>`
        //             } else {
        //                 return `<div class="date-hour">A</div>`
        //             }
        //         } else {
        //             return `<div class="date-hour"></div>`
        //         }
        //
        //     }
        //
        //     const worked = this.getTotalWorked(attendance);
        //     const break_time = this.getTotalBreakTime(attendance);
        //
        //     const balance = this.getBalance(scheduled.asSeconds(), worked.asSeconds(), paid_leave);
        //
        //     if (holiday) {
        //         if (worked.asSeconds() > 0) {
        //             return `<div class="date-hour">P</div>`
        //         } else {
        //             return `<div class="date-hour">H</div>`
        //         }
        //     }
        //
        //
        //     if (scheduled.asSeconds() > 0) {
        //         if (worked.asSeconds() > 0) {
        //             return `<div class="date-hour">P</div>`
        //         } else {
        //             return `<div class="date-hour">A</div>`
        //         }
        //     } else {
        //         if (worked.asSeconds() > 0) {
        //             return `<div class="date-hour">P</div>`
        //         } else {
        //             return `<div class="date-hour">A</div>`
        //         }
        //     }
        //
        // },

        formatEmployeeAttendances(employee, date) {
            const attendance = this.getAttendance(employee, date);
            const workShiftDetails = this.getDetails(
                this.getEmployeeWorkingShiftFromDate(
                    employee.working_shifts,
                    date,
                    this.defaultWorkingShift
                ),
                date,
            );
            const holiday = this.isHoliday(date, employee.holidays);
            const scheduled = holiday ? moment.duration('00:00') : this.getScheduled(workShiftDetails);
            const paid_leave = Number(this.getTotalPaidLeave(employee, workShiftDetails, date, holiday));

            if (!attendance) {
                if (scheduled.asSeconds() > 0) {
                    return paid_leave ? 'L' : 'A';
                } else {
                    return ''; // You may want to change this based on your preference for empty cells
                }
            }

            const worked = this.getTotalWorked(attendance);
            const break_time = this.getTotalBreakTime(attendance);
            const balance = this.getBalance(scheduled.asSeconds(), worked.asSeconds(), paid_leave);

            if (holiday) {
                return worked.asSeconds() > 0 ? 'P' : 'H';
            }

            if (scheduled.asSeconds() > 0) {
                return worked.asSeconds() > 0 ? 'P' : 'A';
            } else {
                return worked.asSeconds() > 0 ? 'P' : 'A';
            }
        },
        getAttendanceSummaries(employee) {
            const {scheduled, worked, break_time, paid_leave, balance} = this.ranges.map(date => {
                const workShiftDetails = this.getDetails(
                    this.getEmployeeWorkingShiftFromDate(employee.working_shifts, date, this.defaultWorkingShift),
                    date
                );
                const holiday = this.isHoliday(date, employee.holidays);
                const attendance = this.getAttendance(employee, date);
                const scheduled = holiday ? 0 : this.getScheduled(workShiftDetails).asSeconds();
                const worked = attendance ? this.getTotalWorked(attendance).asSeconds() : 0;
                const break_time = attendance ? this.getTotalBreakTime(attendance).asSeconds() : 0;
                const paid_leave = this.getTotalPaidLeave(employee, workShiftDetails, date, holiday);
                const balance = this.getBalance(scheduled, worked, paid_leave);
                return {
                    scheduled,
                    worked,
                    break_time,
                    paid_leave,
                    balance
                };
            }).reduce((prev, attendance) => {
                prev.scheduled += attendance.scheduled;
                prev.worked += attendance.worked;
                prev.break_time += attendance.break_time;
                prev.paid_leave += attendance.paid_leave;
                prev.balance += attendance.balance
                return prev;
            }, {
                scheduled: 0,
                worked: 0,
                break_time: 0,
                paid_leave: 0,
                balance: 0
            });

            return {
                scheduled: convertSecondToHourMinutes(scheduled),
                worked: convertSecondToHourMinutes(worked),
                break_time: convertSecondToHourMinutes(break_time),
                paid_leave: convertSecondToHourMinutes(paid_leave),
                balance: convertSecondToHourMinutes(balance),
            }

        },
        getTotalPaidLeave(employee, workingShiftDetails, date, holiday) {
            if (parseInt(workingShiftDetails.is_weekend) === 1 || !!holiday) {
                return moment.duration(0);
            }
            let leaves = employee.leaves.filter(leave => {
                return moment(date.format(serverDateFormat))
                    .isBetween(moment(leave.start_at).format(serverDateFormat), moment(leave.end_at).format(serverDateFormat), 'days', '[]')
            })
            return leaves.reduce((totalSec, leave) => {
                if (leave && (leave.duration_type === 'first_half' || leave.duration_type === 'last_half')) {
                    return totalSec + (moment.duration(differentInTime(workingShiftDetails.start_at, workingShiftDetails.end_at)).asSeconds()) / 2;
                } else if (leave && leave.duration_type === 'hours') {
                    return totalSec + moment.duration(differentInTime(moment(leave.start_at).format(serverTimeFormat), moment(leave.end_at).format(serverTimeFormat))).asSeconds();
                }
                return totalSec + (leave ? moment.duration(differentInTime(workingShiftDetails.start_at, workingShiftDetails.end_at)).asSeconds() : moment.duration(0).asSeconds());
            }, 0);
        },

        getAttendance(employee, date) {
            return this.memoize(`attendance-${employee.id}-${date.format(serverDateFormat)}`, () => {
                return employee.attendances.find(attendance => {
                    return attendance.in_date === date.format(serverDateFormat);
                });
            });
        },
        getScheduled(details) {
            if (!details) {
                return moment.duration("00:00");
            }
            return this.memoize(`work-shift-details-${details.id}`, () => {
                if (parseInt(optional(details, 'is_weekend'))) {
                    return moment.duration("00:00");
                }
                return differentInTime(details.start_at, details.end_at);
            });
        },
        getBalance(scheduled, worked, paid_leave) {
            if (paid_leave) {
                return (worked + paid_leave) - scheduled;
            }
            return worked - scheduled;
        },
        isHoliday(date, holidays) {
            return holidays.find(holiday => date.isSame(holiday, 'day'))
        },
        formatTitleRangeDate(range) {
            let date = range.locale(window.appLanguage)
            return date.format('MMM D') + ' - ' + date.format('ddd');
        }
    },
    watch: {
        queryString: {
            handler: function (queryString) {
                if (!queryString) {
                    return;
                }
                this.getAttendances(queryString)
            },
            immediate: true
        }
    }
}
</script>